import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M12 0C8.1 0 4.579 2.006 2.551 5.146c-1 1.548-1.423 3.154-1.548 4.777L1 14a3 3 0 0 0 3 3h2V9H3.137a7.604 7.604 0 0 1 1.094-2.77 9.248 9.248 0 0 1 15.538 0c.495.768.834 1.638 1.054 2.57l.04.2H18v8h2.344a7.216 7.216 0 0 1-1.063 1.818C18.183 20.165 16.556 21 14.263 21H14a2 2 0 1 0-2 2h2.263c2.842 0 5.058-1.066 6.568-2.919 1.484-1.82 2.21-4.305 2.316-7.042.058-1.506-.01-3.124-.373-4.678a9.55 9.55 0 0 0-1.325-3.215A11.248 11.248 0 0 0 12 0Zm8 11h1.133a19.4 19.4 0 0 1 .015 1.961c-.027.72-.102 1.4-.223 2.039H20v-4ZM3 14v-3h1v4a1 1 0 0 1-1-1Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.744 12.5 9 7.08v10.84l7.744-5.42Zm-3.488 0L11 14.08v-3.16l2.256 1.58Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionPlayCall24 = createIcon(IconComponent);